import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import * as API from 'api';
import * as UTILS from 'utilities';
import * as CONSTANTS from 'constants';
import * as ACTIONS_SEARCH from 'actions/Search';
import * as ACTIONS_APP from 'actions/App';

const getErrorDetails = (state) => state.search.errorStatDetails;
const getErrorHeader = (state) => state.search.errorHeader;
const getErrorsAll = (state) => state.search.searchErrors;

function* requestFetchSearchResults({ payload }) {
    try {
        yield put(ACTIONS_SEARCH.setSearchResults(null));
        const search = yield call(API.POST, payload.url, payload.data);
        if (!search || !search.data) {
            yield put(ACTIONS_SEARCH.setSearchResults([]));
        } else {
            yield put(ACTIONS_SEARCH.setSearchResults(search.data.results));
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setSearchResults([]));
    }
}

function* requestFetchSearchDevicesOrGateways({ payload }) {
    try {
        yield put(ACTIONS_SEARCH.setSearchDevicesOrGateways(null));
        const search = yield call(API.POST, payload.url, payload.data);
        if (!search || !search.data) {
            yield put(ACTIONS_SEARCH.setSearchDevicesOrGateways([]));
        } else {
            yield put(ACTIONS_SEARCH.setSearchDevicesOrGateways(search.data.results));
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setSearchDevicesOrGateways([]));
    }
}

function* requestFetchSearchDeviceHistory({payload}) {
    try {
        yield put(ACTIONS_SEARCH.setSearchDeviceHistory([]));
        const deviceHistory = yield call(API.POST, payload.url, payload.data);
        if (!deviceHistory || !deviceHistory.data) {
            yield put(ACTIONS_SEARCH.setSearchDeviceHistory(null));
        } else {
            yield put(ACTIONS_SEARCH.setSearchDeviceHistory(deviceHistory.data.results));
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setSearchDeviceHistory([]));
    }
}

function* requestFetchUserVersionHistory({payload}) {
    try {
        yield put(ACTIONS_SEARCH.setUserVersionHistory([]));
        const userVersionHistory = yield call(API.POST, payload.url, payload.data);
        if (!userVersionHistory || !userVersionHistory.data) {
            yield put(ACTIONS_SEARCH.setUserVersionHistory(null));
        } else {
            yield put(ACTIONS_SEARCH.setUserVersionHistory(userVersionHistory.data));
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setUserVersionHistory([]));
    }
}

function* requestFetchSearchResultsError({ payload }) {
    try {
        yield put(ACTIONS_SEARCH.setSearchResultsError(null));
        const search = yield call(API.POST, payload.url, payload.data);
        if (!search || !search.data) {
            yield put(ACTIONS_SEARCH.setSearchResultsError(null));
        } else {
            yield put(ACTIONS_SEARCH.setSearchResultsError(search.data));
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setSearchResultsError([]));
    }
}

function* requestFetchAllSearchErrors({ payload }) {
    let errorsList = yield select(getErrorsAll);
    try {
        if(payload.page == 1){
            yield put(ACTIONS_SEARCH.setAllSearchErrors(null));
        }
        const search = yield call(API.POST, payload.url, payload.data);
        if (!search || !search.data) {
            yield put(ACTIONS_SEARCH.setAllSearchErrors([]));
        } else {
            let errorHeader = yield select(getErrorHeader);
            let activeHeader = errorHeader.find((item) => item.active);
            if(payload.page == 1){
                search.data = UTILS.sortList(!activeHeader.order, search.data, activeHeader.sortTitle);
                yield put(ACTIONS_SEARCH.setAllSearchErrors(search.data));
            } else {
                let addedList = errorsList.concat(
                    search && search.data ? search.data : []
                )
                addedList = UTILS.sortList(!activeHeader.order, addedList, activeHeader.sortTitle);
                yield put(ACTIONS_SEARCH.setAllSearchErrors(addedList));
            }
        }
    } catch (error) {
        console.warn(error);
        yield put(ACTIONS_SEARCH.setAllSearchErrors([]));
    }
}


export function* selectFetchSearchResults() {
    yield takeEvery(CONSTANTS.FETCH_SEARCH_RESULTS, requestFetchSearchResults);
}
export function* selectFetchSearchDevices() {
    yield takeEvery(CONSTANTS.FETCH_SEARCH_DEVICES, requestFetchSearchDevicesOrGateways);
}
export function* selectFetchSearchGateways() {
    yield takeEvery(CONSTANTS.FETCH_SEARCH_GATEWAYS, requestFetchSearchDevicesOrGateways);
}
export function* selectFetchSearchResultsError() {
    yield takeEvery(CONSTANTS.FETCH_SEARCH_RESULTS_ERROR, requestFetchSearchResultsError);
}
export function* selectFetchAllSearchErrors() {
    yield takeEvery(CONSTANTS.FETCH_ALL_SEARCH_ERRORS, requestFetchAllSearchErrors);
}
export function* selectFetchSearchDeviceHistory() {
    yield takeEvery(CONSTANTS.FETCH_SEARCH_DEVICE_HISTORY, requestFetchSearchDeviceHistory);
}
export function* selectFetchUserVersionHistory() {
    yield takeEvery(CONSTANTS.FETCH_USER_VERSION_HISTORY, requestFetchUserVersionHistory);
}


export default function* rootSaga() {
    yield all([
        fork(selectFetchSearchResults),
        fork(selectFetchSearchDevices),
        fork(selectFetchSearchGateways),
        fork(selectFetchSearchResultsError),
        fork(selectFetchAllSearchErrors),
        fork(selectFetchSearchDeviceHistory),
        fork(selectFetchUserVersionHistory)
    ]);
}
